import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, MessageSquare } from 'lucide-react';
import { aufgabenAPI } from '@/lib/api';

/* Zaehler im Kopf aller CRM-Seiten (Betreiber 19.09.2026): zwei Zahlen, die
   jemand heute auf null bringen kann — eigene faellige Aufgaben (ohne Altlast)
   und unbeantwortete Chats. Ersetzt den alten Freigabe-Zaehler (315 offene
   Entwuerfe, die niemand bediente). Faellt der Endpunkt aus, bleibt er weg. */
export default function FreigabeZaehler() {
  const navigate = useNavigate();
  const [z, setZ] = useState(null);
  useEffect(() => {
    let aktiv = true;
    const lade = async () => {
      try { const r = await aufgabenAPI.zaehler(); if (aktiv) setZ(r.data); } catch { if (aktiv) setZ(null); }
    };
    lade();
    const t = setInterval(lade, 60000);
    return () => { aktiv = false; clearInterval(t); };
  }, []);
  if (!z) return null;
  const knopf = 'flex items-center gap-1 rounded-full px-2 h-7 text-xs font-medium';
  return (
    <div className="flex items-center gap-1.5" data-testid="kopf-zaehler">
      <button onClick={() => navigate('/heute')} title={`${z.faellig} heute fällig${z.ueberfaellig ? `, davon ${z.ueberfaellig} überfällig` : ''}`}
              className={`${knopf} ${z.ueberfaellig > 0 ? 'bg-red-600 text-white' : z.faellig > 0 ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'}`}
              data-testid="zaehler-faellig">
        <ClipboardList className="h-3.5 w-3.5" />{z.faellig}<span className="hidden sm:inline font-normal">{z.ueberfaellig > 0 ? ` fällig · ${z.ueberfaellig} überfällig` : ' fällig'}</span>
      </button>
      {z.unbeantwortet > 0 && (
        <button onClick={() => navigate('/posteingang')} title={`${z.unbeantwortet} Chats unbeantwortet`}
                className={`${knopf} bg-amber-500/15 text-amber-700 dark:text-amber-400`} data-testid="zaehler-unbeantwortet">
          <MessageSquare className="h-3.5 w-3.5" />{z.unbeantwortet}<span className="hidden sm:inline font-normal"> unbeantwortet</span>
        </button>
      )}
    </div>
  );
}
